import React from 'react';

const Blog = () => {
  return (
    <section className="py-5 bg-white" id="blog">
      <div className="container py-4">
        <div className="row">
          <div className="col-lg-8 mx-auto text-center mb-5">
            <span className="badge bg-primary bg-opacity-10 text-primary px-3 py-2 rounded-pill mb-3">
              📝 Our Blog
            </span>
            <h2 className="display-5 fw-bold mb-4">Latest Blog & Articles</h2>
            <p className="lead text-muted">
              Stay inspired, updated, and informed. From creator success stories to app tips — here's what's happening around MastiShorts.
            </p>
          </div>
        </div>
        
        <div className="row g-4">
          <div className="col-lg-4">
            <div className="card h-100 border-0 shadow-sm rounded-4 overflow-hidden hover-lift">
              <div className="position-relative">
                <img src="/img/blog1.jpg" className="card-img-top" alt="Blog Post 1" style={{ height: '250px', objectFit: 'cover' }} />
                <div className="position-absolute top-0 start-0 m-3">
                  <span className="badge bg-primary text-white px-2 py-1 rounded-pill small">Blog Post</span>
                </div>
                <div className="position-absolute bottom-0 end-0 m-3">
                  <span className="badge bg-dark bg-opacity-75 text-white px-2 py-1 rounded-pill small">
                    <i className="fas fa-clock me-1"></i>Aug 1, 2024
                  </span>
                </div>
              </div>
              <div className="card-body p-4">
                <h5 className="card-title mb-3">
                  <a href="#" className="text-decoration-none text-dark">5 Proven Tips to Boost Your Live Audience</a>
                </h5>
                <p className="card-text text-muted mb-4">
                  Want more viewers? Discover how successful streamers keep their audience hooked and gifts flowing. Whether you're new or pro, these tips will level up your presence.
                </p>
                <a href="#" className="btn btn-primary rounded-pill px-4 py-2">
                  Read More <i className="fas fa-arrow-right ms-1"></i>
                </a>
              </div>
            </div>
          </div>
          
          <div className="col-lg-4">
            <div className="card h-100 border-0 shadow-sm rounded-4 overflow-hidden hover-lift">
              <div className="position-relative">
                <img src="/img/blog2.jpg" className="card-img-top" alt="Blog Post 2" style={{ height: '250px', objectFit: 'cover' }} />
                <div className="position-absolute top-0 start-0 m-3">
                  <span className="badge bg-success text-white px-2 py-1 rounded-pill small">Tutorial</span>
                </div>
                <div className="position-absolute bottom-0 end-0 m-3">
                  <span className="badge bg-dark bg-opacity-75 text-white px-2 py-1 rounded-pill small">
                    <i className="fas fa-clock me-1"></i>Aug 1, 2024
                  </span>
                </div>
              </div>
              <div className="card-body p-4">
                <h5 className="card-title mb-3">
                  <a href="#" className="text-decoration-none text-dark">Behind the Scenes: How PK Battles Work</a>
                </h5>
                <p className="card-text text-muted mb-4">
                  Ever wondered how PK Battles really function? Here's a deep dive into how the points, gifts, timers, and rankings all come together in real-time.
                </p>
                <a href="#" className="btn btn-success rounded-pill px-4 py-2">
                  Read More <i className="fas fa-arrow-right ms-1"></i>
                </a>
              </div>
            </div>
          </div>
          
          <div className="col-lg-4">
            <div className="card h-100 border-0 shadow-sm rounded-4 overflow-hidden hover-lift">
              <div className="position-relative">
                <img src="/img/blog3.png" className="card-img-top" alt="Blog Post 3" style={{ height: '250px', objectFit: 'cover' }} />
                <div className="position-absolute top-0 start-0 m-3">
                  <span className="badge bg-warning text-dark px-2 py-1 rounded-pill small">News</span>
                </div>
                <div className="position-absolute bottom-0 end-0 m-3">
                  <span className="badge bg-dark bg-opacity-75 text-white px-2 py-1 rounded-pill small">
                    <i className="fas fa-clock me-1"></i>Aug 1, 2024
                  </span>
                </div>
              </div>
              <div className="card-body p-4">
                <h5 className="card-title mb-3">
                  <a href="#" className="text-decoration-none text-dark">MastiShorts Creator Spotlight: Success Stories</a>
                </h5>
                <p className="card-text text-muted mb-4">
                  Meet the creators who've turned their passion into income. From zero followers to thousands — real stories from real people making it big.
                </p>
                <a href="#" className="btn btn-warning rounded-pill px-4 py-2">
                  Read More <i className="fas fa-arrow-right ms-1"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Blog;
